import ClientActiveExpiryCard from "components/ui/ClientFlow/ClientActiveExpiryCard";
import React, { useContext, useEffect, useState } from "react";
import { getActiveCatalogs, getExpiryCatalogs, useCatalogs } from "./api/catalogPageApi";
import { Grid } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";
import SortContext from "context/SortContext";
import { useClientContext } from "context/ClientContext";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";

function ClientsCatalogTypeWrapper() {
  const location = useLocation();
  const state = location?.state;

  const { clientId } = useParams();

  console.log("state in wrapper:", state);
  const [catalogData, setCatalogData] = useState([]);
  const {
    setFilterChangeCount,
    setDisplayCount,
    setFilterChangeDesignCount,
    setSearchResultCount,
    setSearchSuffix,
    dynamicfilterCount,
    filterChangeCount,
    filterChangeDesignCount,
    setSearchPlaceHolder,
  } = useGlobalContext();
  const { setSortOptions, setSearch } = useContext(SortContext);

  const {
    data: catalogDataFromApi,
    isLoading,
    isFetching,
    isError,
  } = useCatalogs({
    isActiveCatalog: state?.isActiveCatalog,
    clientCode: clientId,
  });

  useEffect(() => {
    if (catalogDataFromApi?.length) {
      console.log("catalogDataFromApi-->", catalogDataFromApi);
      let data = catalogDataFromApi || [];
      setCatalogData(data);
    }
  }, [catalogDataFromApi]);

  useEffect(() => {
    setSearch(true);
    setSearchPlaceHolder("Search by Catalog name");
    if (dynamicfilterCount) {
      setFilterChangeCount(catalogData.length);
      // setFilterChangeDesignCount(catalogData.length);
      setSearchResultCount(0);
    } else {
      setSearchResultCount(0);
      setFilterChangeCount(filterChangeCount);
      // setFilterChangeDesignCount(filterChangeDesignCount);
    }
    setDisplayCount(true);
    setSearchSuffix("");

    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      // setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchSuffix("");
      setSearchPlaceHolder("");
      setSearch(false);
    };
  }, [catalogData]);

  useEffect(() => {
    setSortOptions(["d", "e", "f"]);

    return () => {
      setSortOptions([]);
    };
  }, []);

  if (isLoading) {
    return <LoadingSmallCard count={20} />;
  }

  return (
    <div>
      <Grid container className="Grid-padding" direction="row" sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "30px", rowGap: "32px",maxHeight: "calc(100vh - 150px)", overflowY: "auto", scrollbarWidth: "none" }}>
        {catalogData?.length > 0 &&
          catalogData?.map((catalog) => {
            return <ClientActiveExpiryCard data={catalog} isActiveCat={state?.isActiveCatalog} />;
          })}
      </Grid>
    </div>
  );
}

export default ClientsCatalogTypeWrapper;
